import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_82f7828c-c7a0-48a6-b1cb-fc4aadec5e5f/artifacts/4dy14776_Order%20%26%20Clean%20Co-%20Main%20Logo.jpeg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/services", label: "Services" },
    { path: "/enhancements", label: "Upgrades" },
    { path: "/booking", label: "Book Now" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img 
              src={LOGO_URL} 
              alt="Order & Clean Co." 
              className="h-14 w-14 object-contain rounded-full"
            />
            <div className="hidden sm:block">
              <span className="font-bold text-lg tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                ORDER & CLEAN CO
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`uppercase font-bold text-sm tracking-widest transition-colors ${
                  isActive(link.path)
                    ? "text-[#1a365d]"
                    : "text-slate-700 hover:text-[#1a365d]"
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/booking"
              className="btn-primary"
              data-testid="nav-cta"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-slate-100 animate-fade-in">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`uppercase font-bold text-sm tracking-widest py-2 ${
                    isActive(link.path)
                      ? "text-[#1a365d]"
                      : "text-slate-700"
                  }`}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/booking"
                className="btn-primary text-center mt-2"
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-cta"
              >
                Get Started
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
